export const enum NotificationFilterApplyEnum {
  Product = 1,
  Couriers = 2,
  Origin = 3,
  Destination = 4,
  Teams = 5,
}

/** Event types on the chain-of-custody timeline. Mirrors backend CoCEventType. */
export enum CoCEventType {
  /** User comment or reply on the timeline */
  Comment = 1,
  /** Custody handoff event (handler, location, action) */
  CustodyEvent = 2,
  /** Shipment alert (temperature, location, etc.) */
  Alert = 3,
  /** Document or file attachment */
  FileUpload = 4,
  /** CoC message (with attachments, mentions, audience controls) */
  CocMessage = 5,
  /** Scheduled one-time notification (SMS, email, AI call/email) */
  OneTimeNotification = 6,
  /** Inbound/outbound AI call alert */
  AiCallAlert = 7,
  /** Chain of custody note created by a Logiblocks workflow */
  WorkflowAction = 8,
  /** Customer notification sent via shipment_contact (SMS or email) */
  CustomerNotification = 9,
  /** gxp report availabel or gxp coc event */
  GxPReport = 10,
}

export enum MenuLabels {
  Shipment = 'shipment',
  Settings = 'settings',
  Automations = 'automations',
}

export enum FeatureLabels {
  Alerts = 'alerts',
  RecordManagement = 'record_management',
}

export enum SubMenuLabels {
  Gxp_reports = 'gxp_reports',
  AlertCustomization = 'alert_customization',
  Products = 'products',
  Locations = 'locations',
}

export enum InboundNotification {
  Inbound_call_received = 1,
  Outbound_call_triggered = 2,
  Outbound_email_triggered = 3,
  Needs_attention_from_AI_action = 4,
}

export const FiltersLabelMap = {
  saved_filters: 'Saved filter sets',
  team: 'Team',

  from_location: 'Origin address',
  to_location: 'Destination address',
  origin_state: 'Origin state',
  destination_state: 'Destination state',
  location_type: 'Location type',

  alert_types: 'Alerts',
  alert_assignment: 'Alert assignment',
  type: 'Risk',
  last_open_alert_aging: 'Last open alert aging',

  status: 'Progress',
  delivery_status: 'Timeliness',
  pod_status: 'POD Status',

  product: 'Product',
  product_type: 'Product type',
  project_id: 'Project ID',
  temperature: 'Temperature',
  courier: 'Transport provider',
  link_code: 'Linked shipments',

  scheduled_pickup_date: 'Pickup date',
  customer_defined_ship_date: 'Customer Defined Ship Date',
  created_at: 'Created date',
  scheduled_delivery_date: 'Delivery date',

  ARCHIVED: 'Archived',
};

export enum OperationType {
  Read = 'read',
  Write = 'write',
  NonBlockedWrite = 'non-blocked-write',
  // Blocked the same as Write in a read-only preview, but silently -- for
  // background side-effect writes (e.g. mark-as-read) that aren't a direct
  // user action, so blocking them shouldn't surface a "read-only" toast.
  SilentWrite = 'silent-write',
}

export enum BeaconEventType {
  AlertViewed = 'alert_viewed',
  ReportViewed = 'report_viewed',
  NotificationViewed = 'notification_viewed',
  InsightChatbotOpened = 'insight_chatbot_opened',
  HelpOpened = 'help_opened',
  MessagesOpened = 'messages_opened',
}
